import { createStandardAction } from 'typesafe-actions';
import { FiltersReducer } from "@lon/shared/types";

export const setFilters = createStandardAction('APP/SET_FILTERS')<Partial<FiltersReducer>>();
